import React from "react";

const STORE = {
  name: "Jaggi Sweets",
  tagline: "Official Billing & POS System",
  footer: [
    "Thank you for shopping at Jaggi Sweets!",
    "Visit Again!",
    "Software by Jaggi Tech",
  ],
};

export default function BillReceipt({ bill, receiptId = 'searchReceipt' }) {
  if (!bill) return null;
  const settings=bill.receipt_snapshot||{};

  return (
    <div
      id={receiptId}
      className="w-[320px] bg-white text-black p-3 font-mono text-xs"
      style={{width:'80mm',maxWidth:'100%'}}
    >
      <div className="text-center font-bold text-lg">
        {settings.legal_name||STORE.name}
      </div>
      {settings.address&&<div className="text-center whitespace-pre-line">{settings.address}</div>}
      {settings.gstin&&<div className="text-center">GSTIN: {settings.gstin}</div>}
      {settings.phone&&<div className="text-center">Contact: {settings.phone}</div>}
      {bill.void&&<div className="text-center font-bold">VOID — NOT A VALID SALE</div>}
      {bill.refund&&<div className="text-center font-bold">REFUND RECEIPT</div>}

      <div className="text-center">
        {STORE.tagline}
      </div>

      <hr className="my-2" />

      <div>Bill No : {bill.bill_no}</div>

      <div>Token : {bill.token_no}</div>

      <div>Payment : {bill.payment_mode}</div>
      {bill.customer&&<div>Customer: {bill.customer.name} {bill.customer.mobile||''}</div>}

      <div>
        Date :
        {bill.created_at
          ? new Date(bill.created_at).toLocaleString()
          : "-"}
      </div>

      <hr className="my-2" />

      <div className="font-bold text-center mb-2">
        ITEMS
      </div>

      {(bill.items || []).map((item, index) => (
        <div
          key={index}
          className="flex justify-between"
        >
          <span>
            {item.name} × {item.grams != null ? `${Number(item.grams)} g` : `${Number(item.qty)} ${item.uom || "PCS"}`}
          </span>

          <span>
            ₹{Number(item.amount || 0).toFixed(2)}
          </span>
        </div>
      ))}

      <hr className="my-2" />

      <div className="flex justify-between"><span>Subtotal</span><span>₹{Number(bill.subtotal || 0).toFixed(2)}</span></div>
      {Object.entries(bill.tax_totals || {}).map(([name, amount]) => (
        <div key={name} className="flex justify-between"><span>{name}</span><span>₹{Number(amount).toFixed(2)}</span></div>
      ))}
      <div className="flex justify-between"><span>Discount</span><span>₹{Number(bill.discount || 0).toFixed(2)}</span></div>
      <div className="flex justify-between"><span>Round off</span><span>₹{Number(bill.round_off||0).toFixed(2)}</span></div>
      <div className="flex justify-between">
        <span>Total</span>

        <span>₹{Number(bill.grand_total || 0).toFixed(2)}</span>
      </div>

      {bill.remarks && (
        <>
          <hr className="my-2" />

          <div>{bill.remarks}</div>
        </>
      )}

      <hr className="my-2" />

      {(settings.footer?[settings.footer]:STORE.footer).map((f, i) => (
        <div
          key={i}
          className="text-center text-[10px]"
        >
          {f}
        </div>
      ))}
    </div>
  );
}
